import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ListingVideo } from 'ha/services/apiV2/types/Listing';

export default (makeCall: MakeCall) => (listingId: number, videoId: number) =>
  makeCall<ListingVideo[]>(
    'PUT',
    `/api/v2/listing/${listingId}/video/${videoId}/confirm`,
  );
